<template>
  <StatusBar @toggle-sidebar="toggleSidebar" />
  <div class="main-container">
    <Sidebar 
      @file-selected="handleFileSelected"
      :class="{ 'sidebar-hidden': !sidebarVisible }"
      :default-path="defaultPath"
      :files="files"
    />
    <div class="sidebar-backdrop" v-if="sidebarVisible" @click="toggleSidebar"></div>
    <main class="content" :class="{ 'full-width': !sidebarVisible }">
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
import Sidebar from "@/components/Sidebar.vue";
import StatusBar from "@/components/StatusBar.vue";
import loadMarkdownEnFiles from "@/utils/loadMarkdownEn";

export default {
  name: 'MainEnLayout',
  components: {
    Sidebar,
    StatusBar
  },
  data() {
    return {
      sidebarVisible: window.innerWidth > 768,
      defaultPath: 'en',
      files: []
    };
  },
  created() {
    this.files = loadMarkdownEnFiles();
  },
  methods: {
    toggleSidebar() {
      this.sidebarVisible = !this.sidebarVisible;
    },
    handleFileSelected() {
      if (window.innerWidth <= 768) {
        this.sidebarVisible = false;
      }
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.main-container {
  display: flex;
  margin-top: 50px; /* 为顶部状态栏留出空间 */
  height: calc(100vh - 50px);
  overflow: hidden;
}

.content {
  flex: 1;
  padding: 20px;
  overflow: auto;
  text-align: left;
}

/* 默认主题（浅色） */
:root {
  --bg-primary: #ffffff;
  --bg-secondary: #f8f9fa;
  --text-primary: #2c3e50;
  --text-secondary: #6c757d;
  --border-color: #e9ecef;
  --hover-bg: #e9ecef;
  --selected-bg: #e3e8ec;
}

/* 深色主题 */
body.dark-mode {
  --bg-primary: #1a1a1a;
  --bg-secondary: #2d2d2d;
  --text-primary: #e1e1e1;
  --text-secondary: #a0a0a0;
  --border-color: #404040;
  --hover-bg: #363636;
  --selected-bg: #404040;
}

body {
  background-color: var(--bg-primary);
  color: var(--text-primary);
}

/* 添加深色主题样式 */
body.dark-theme {
  background-color: #1a1a1a;
  color: #ffffff;
}

/* 代码块样式 */
pre {
  background-color: #2d2d2d;
  color: #d4d4d4;
  padding: 10px;
  border-radius: 5px;
}

.dark-theme .sidebar {
  background-color: #2d2d2d;
}

.sidebar {
  transition: transform 0.3s ease;
}

@media (max-width: 768px) {
  .sidebar {
    position: fixed;
    left: 0;
    top: 50px;
    bottom: 0;
    z-index: 100;
  }

  .sidebar-hidden {
    transform: translateX(-100%);
  }

  .content.full-width {
    margin-left: 0;
  }

  .sidebar-backdrop {
    position: fixed;
    top: 50px;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 99;
  }
}

.content {
  transition: margin-left 0.3s ease;
}
</style> 